import Vue from 'vue'
import Router from 'vue-router'
import common from './common'
import home from './home'
import product from './product'
import partner from './partner'
import about from './about'
import serviceArea from './serviceArea'
import App from '@/App'
import eachHook from './hook'
let Common = resolve => require(['@/views/Common.vue'], resolve)
Vue.use(Router)

const route = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'App',
            component: App,
            children: [{
                path: '/',
                name: "Common",
                component: Common,
                meta: {
                    title: '首页'
                },
                children: [
                    ...home,
                    ...product,
                    ...partner,
                    ...about,
                    ...serviceArea
                ]
            }, ]
        },
        ...common
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})
route.beforeEach((to,from,next)=>{
    // console.log(to.path);
    if(to.path == '/') next();
    
})
eachHook(route)
export default route